import { render, staticRenderFns } from "./AddAttachmentTabbedForm.vue?vue&type=template&id=406e837a"
import script from "./AddAttachmentTabbedForm.vue?vue&type=script&lang=js"
export * from "./AddAttachmentTabbedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports